import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';
import { ContentFilteringStore } from '../../stores/BrowserPolicies/ContentFilteringStore';
import { ConsoleCard, ConsoleCardTitle } from '../ConsoleFragments';
import FilterByCategory from './FilterByCategory';
import FilterByUrl from './FilterByUrl';
import ControlWrapper from '../ConsoleFragments/ConsoleField';
import Toggle from '../Toggle/Toggle';
import './ContentFiltering.css';

const block = b_.lock('ContentFiltering');

class ContentFiltering extends Component {
    static propTypes = {
        contentFilteringStore: ContentFilteringStore.PropType.isRequired,
    };

    render() {
        const { contentFilteringStore } = this.props;

        return <Fragment>
            <ControlWrapper
                name="Filter Content"
                info="Filter web content by categories and/or specific URLs."
                infoPosition="right"
                className={block('SwitchControlWrapper')}
            >
                <Toggle
                    onLabel={'ENABLED'}
                    offLabel={'DISABLED'}
                    checked={contentFilteringStore.filterContentSwitchStore.isEnabled}
                    onChange={contentFilteringStore.filterContentSwitchStore.toggle}
                />
            </ControlWrapper>

            {contentFilteringStore.filterContentSwitchStore.isEnabled ? <Fragment>
                <FilterByCategory
                    categoryFilterStore={contentFilteringStore.categoryFilterStore}
                />
                <FilterByUrl
                    urlFilterStore={contentFilteringStore.urlFilterStore}
                />

                <ConsoleCard>
                    <ConsoleCardTitle>
                        SECURITY AWARENESS TRAINING
                    </ConsoleCardTitle>
                    <ControlWrapper
                        name="Allow Proofpoint Training Domains"
                        info="This option will allow all Proofpoint Security Awareness Training domains
                              to be viewed regardless of other Content Filtering options."
                        infoPosition="right"
                        className={block('WhitelistThreatSim')}
                    >
                        <Toggle
                            onLabel={'ENABLED'}
                            offLabel={'DISABLED'}
                            checked={contentFilteringStore.whitelistThreatSimStore.isEnabled}
                            onChange={contentFilteringStore.whitelistThreatSimStore.toggle}
                        />
                    </ControlWrapper>
                </ConsoleCard>
            </Fragment> : null}
        </Fragment>;
    }
}

export default observer(ContentFiltering);
